/* Aimer Joias — Linha Classic (varejo)
   - compra rápida dos cards (.acl-card form[data-acl-add]) com a gaveta do Dawn
   - página /collections/classic: filtros, chips de pedra, quiz "Descubra a sua pedra", barra do trio
   Sem dependências. Carregado com defer pela seção aimer-classic e pelo bloco do produto. */
(function () {
  'use strict';
  if (window.__aimerClassic) return;
  window.__aimerClassic = true;

  var TRIO = 3;
  var doc = document;
  var root = doc.getElementById('acl');
  var dados = {};
  try { dados = JSON.parse((doc.getElementById('acl-dados') || {}).textContent || '{}'); } catch (e) { dados = {}; }

  function idsClassic() {
    var fonte = (root && root.getAttribute('data-ids')) || (doc.querySelector('[data-acl-ids]') || { getAttribute: function () { return ''; } }).getAttribute('data-acl-ids') || '';
    return fonte.split(',').filter(Boolean).map(Number);
  }
  var IDS = idsClassic();

  function gaveta() { return doc.querySelector('cart-drawer'); }
  function rastrear(evento, params) {
    try { if (window.gtag) window.gtag('event', evento, params || {}); } catch (e) {}
    try { if (window.fbq) window.fbq('trackCustom', evento, params || {}); } catch (e) {}
  }

  /* ------------------------------------------------------------------ */
  /* Carrinho                                                            */
  /* ------------------------------------------------------------------ */
  function contarClassic(cart) {
    var n = 0, fotos = [];
    (cart.items || []).forEach(function (it) {
      if (IDS.indexOf(Number(it.product_id)) > -1) {
        n += it.quantity;
        for (var q = 0; q < it.quantity; q++) fotos.push(it.image || (it.featured_image && it.featured_image.url) || '');
      }
    });
    return { n: n, fotos: fotos };
  }

  function lerCarrinho() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function frasePeca(falta) { return falta === 1 ? '1 peça' : falta + ' peças'; }

  function adicionar(form) {
    var btn = form.querySelector('.acl-btn--add');
    var msg = form.querySelector('.acl-add__msg');
    var escolhido = form.querySelector('input[name="id"]:checked') || form.querySelector('input[type="hidden"][name="id"]');
    if (!escolhido) {
      form.classList.add('precisa-aro');
      if (msg) msg.textContent = 'Escolha o tamanho do aro.';
      var primeiro = form.querySelector('input[name="id"]');
      if (primeiro) primeiro.focus();
      return;
    }
    form.classList.remove('precisa-aro');
    var txt = btn ? btn.querySelector('.acl-btn__txt') : null;
    var original = txt ? txt.textContent : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-carregando'); }
    if (txt) txt.textContent = 'Adicionando…';
    if (msg) msg.textContent = '';

    var g = gaveta();
    var corpo = { items: [{ id: Number(escolhido.value), quantity: 1 }] };
    if (g && g.getSectionsToRender) {
      corpo.sections = g.getSectionsToRender().map(function (s) { return s.id; });
      corpo.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Não foi possível adicionar agora.');
        var card = form.closest('.acl-card');
        rastrear('classic_add', { pedra: card ? card.getAttribute('data-pedra') : '', tipo: card ? card.getAttribute('data-tipo') : '' });
        if (txt) txt.textContent = 'Adicionado ✓';
        if (g && g.renderContents && res.j.sections) {
          g.classList.remove('is-empty');
          g.renderContents(res.j);
        }
        return lerCarrinho().then(function (cart) {
          var c = contarClassic(cart);
          if (msg) {
            msg.textContent = c.n >= TRIO
              ? 'Trio completo: 10% off nas peças Classic.'
              : 'Falta' + (TRIO - c.n > 1 ? 'm ' : ' ') + frasePeca(TRIO - c.n) + ' Classic para os 10%.';
          }
          atualizarBarra(cart);
        });
      })
      .catch(function (err) {
        if (txt) txt.textContent = original;
        if (msg) msg.textContent = err.message;
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-carregando'); }
        setTimeout(function () { if (txt && txt.textContent === 'Adicionado ✓') txt.textContent = original; }, 2200);
      });
  }

  doc.addEventListener('submit', function (ev) {
    var form = ev.target.closest && ev.target.closest('form[data-acl-add]');
    if (!form) return;
    ev.preventDefault();
    adicionar(form);
  });
  doc.addEventListener('change', function (ev) {
    var form = ev.target.closest && ev.target.closest('form[data-acl-add]');
    if (form && ev.target.name === 'id') {
      form.classList.remove('precisa-aro');
      var msg = form.querySelector('.acl-add__msg');
      if (msg) msg.textContent = '';
    }
  });

  /* ------------------------------------------------------------------ */
  /* Barra do trio (só na página Classic)                                */
  /* ------------------------------------------------------------------ */
  var barra = root ? root.querySelector('[data-acl-barra]') : null;
  var barraVisivel = false;

  function atualizarBarra(cart) {
    if (!barra) return;
    var c = contarClassic(cart);
    var slots = barra.querySelectorAll('.acl-barra__slots i');
    for (var i = 0; i < slots.length; i++) {
      var foto = c.fotos[i];
      slots[i].classList.toggle('is-on', i < c.n);
      slots[i].style.backgroundImage = foto ? 'url("' + foto + (foto.indexOf('?') > -1 ? '&' : '?') + 'width=80")' : '';
    }
    var t = barra.querySelector('.acl-barra__txt');
    var falta = TRIO - c.n;
    if (c.n >= TRIO) t.innerHTML = '<b>Trio completo:</b> 10% off';
    else if (c.n === 0) t.innerHTML = '<b>3 peças</b> = 10% off';
    else t.innerHTML = 'Falta' + (falta > 1 ? 'm' : '') + ' <b>' + frasePeca(falta) + '</b> p/ 10% off';
    if (c.n > 0) mostrarBarra(true);
  }
  function mostrarBarra(v) {
    if (!barra) return;
    barraVisivel = v;
    barra.hidden = false;
    requestAnimationFrame(function () { barra.classList.toggle('is-vis', v); });
  }
  if (barra) {
    barra.querySelector('[data-acl-abrir-carrinho]').addEventListener('click', function () {
      var g = gaveta();
      if (g && g.open) g.open(); else window.location.href = '/cart';
    });
    var hero = root.querySelector('.acl-hero');
    if ('IntersectionObserver' in window && hero) {
      new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { if (!e.isIntersecting) mostrarBarra(true); });
      }, { threshold: 0 }).observe(hero);
    } else { mostrarBarra(true); }
    lerCarrinho().then(atualizarBarra).catch(function () {});
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { lerCarrinho().then(atualizarBarra).catch(function () {}); });
    }
  }

  if (!root) return; /* daqui para baixo, só a página Classic */

  /* ------------------------------------------------------------------ */
  /* Filtros + chips                                                     */
  /* ------------------------------------------------------------------ */
  var filtro = { tipo: '', banho: '' };
  var grupos = Array.prototype.slice.call(root.querySelectorAll('.acl-pedra'));
  var vazio = root.querySelector('.acl-vazio');

  function aplicarFiltros() {
    var algum = false;
    grupos.forEach(function (g) {
      var vis = 0;
      g.querySelectorAll('.acl-card').forEach(function (card) {
        var ok = (!filtro.tipo || card.getAttribute('data-tipo') === filtro.tipo) &&
                 (!filtro.banho || card.getAttribute('data-banho') === filtro.banho);
        card.hidden = !ok;
        if (ok) vis++;
      });
      g.hidden = vis === 0;
      if (vis) algum = true;
      var chip = root.querySelector('.acl-chip[data-alvo="' + g.id + '"]');
      if (chip) chip.classList.toggle('is-off', vis === 0);
    });
    if (vazio) vazio.hidden = algum;
  }
  root.querySelectorAll('.acl-filtros__grupo').forEach(function (grupo) {
    var chave = grupo.getAttribute('data-filtro');
    grupo.addEventListener('click', function (ev) {
      var b = ev.target.closest('.acl-pill');
      if (!b) return;
      grupo.querySelectorAll('.acl-pill').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      filtro[chave] = b.getAttribute('data-valor');
      aplicarFiltros();
      rastrear('classic_filtro', { filtro: chave, valor: filtro[chave] || 'todos' });
    });
  });

  function irPara(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    el.classList.add('is-destaque');
    setTimeout(function () { el.classList.remove('is-destaque'); }, 2400);
  }
  root.querySelectorAll('.acl-chip').forEach(function (chip) {
    chip.addEventListener('click', function (ev) {
      ev.preventDefault();
      var alvo = doc.getElementById(chip.getAttribute('data-alvo'));
      if (alvo && alvo.hidden) { /* filtro escondeu: limpa os filtros */
        filtro.tipo = ''; filtro.banho = '';
        root.querySelectorAll('.acl-filtros__grupo').forEach(function (g) {
          g.querySelectorAll('.acl-pill').forEach(function (x, i) { x.classList.toggle('is-on', i === 0); });
        });
        aplicarFiltros();
      }
      root.querySelectorAll('.acl-chip').forEach(function (x) { x.classList.toggle('is-on', x === chip); });
      irPara(alvo);
      rastrear('classic_pedra', { pedra: chip.getAttribute('data-alvo').replace('pedra-', '') });
    });
  });

  /* chips grudam logo abaixo do cabeçalho do tema, se ele for fixo */
  var chips = root.querySelector('.acl-chips');
  var cab = doc.querySelector('.section-header, sticky-header, .shopify-section-header');
  function ajustarTopo() {
    if (!chips || !cab) return;
    var r = cab.getBoundingClientRect();
    var topo = Math.max(0, Math.round(r.bottom));
    if (getComputedStyle(cab).position === 'static' && !cab.classList.contains('shopify-section-header-sticky')) topo = 0;
    chips.style.top = topo + 'px';
  }
  var agendado = false;
  window.addEventListener('scroll', function () {
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(function () {
      agendado = false;
      ajustarTopo();
      var heroEl = root.querySelector('.acl-hero');
      if (barra && !barraVisivel && heroEl && heroEl.getBoundingClientRect().bottom < 0) mostrarBarra(true);
    });
  }, { passive: true });
  ajustarTopo();

  /* ------------------------------------------------------------------ */
  /* Quiz                                                                */
  /* ------------------------------------------------------------------ */
  var box = root.querySelector('[data-acl-quiz]');
  var pedras = (dados.pedras || []).filter(function (p) { return doc.getElementById('pedra-' + p.id); });
  var familias = dados.familias || [];
  var intencoes = dados.intencoes || [];
  var resp = {};
  var passo = 0;

  function el(tag, cls, html) { var e = doc.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var PERGUNTAS = [
    {
      chave: 'fam', titulo: 'Qual cor chama você primeiro?',
      ops: function () {
        return familias.map(function (f) {
          var grad = f.cores.length > 1 ? 'linear-gradient(90deg,' + f.cores.join(',') + ')' : f.cores[0];
          return { valor: f.id, html: '<span class="acl-op__cor" style="background:' + grad + '"></span>' + esc(f.nome) };
        });
      }
    },
    {
      chave: 'int', titulo: 'O que você quer levar com você agora?',
      ops: function () {
        return intencoes.map(function (i) { return { valor: i.id, html: esc(i.nome) + '<small>' + esc(i.desc) + '</small>' }; });
      }
    },
    {
      chave: 'banho', titulo: 'Ouro ou ródio negro?', tres: true,
      ops: function () {
        return [
          { valor: 'ouro', html: '<span class="acl-op__cor" style="background:linear-gradient(100deg,#7d5a24,#e2c47f,#a67d3a)"></span>Ouro 18k<small>quente, clássico, luminoso</small>' },
          { valor: 'rodio', html: '<span class="acl-op__cor" style="background:linear-gradient(100deg,#1f1f22,#6b6d72,#2a2b2e)"></span>Ródio negro<small>moderno, gráfico, marcante</small>' },
          { valor: 'tanto', html: '<span class="acl-op__cor" style="background:linear-gradient(100deg,#a67d3a 0 50%,#3a3b3f 50% 100%)"></span>Gosto dos dois<small>misturo sem medo</small>' }
        ];
      }
    }
  ];

  function desenharPergunta() {
    var q = PERGUNTAS[passo];
    box.innerHTML = '';
    box.appendChild(el('p', 'acl-q__passo', 'Pergunta ' + (passo + 1) + ' de ' + PERGUNTAS.length));
    var barraQ = el('div', 'acl-q__barra');
    for (var i = 0; i < PERGUNTAS.length; i++) barraQ.appendChild(el('i', i <= passo ? 'is-on' : ''));
    box.appendChild(barraQ);
    box.appendChild(el('h3', 'acl-q__titulo', esc(q.titulo)));
    var ops = el('div', 'acl-q__ops' + (q.tres ? ' acl-q__ops--3' : ''));
    q.ops().forEach(function (o) {
      var b = el('button', 'acl-op' + (resp[q.chave] === o.valor ? ' is-on' : ''), o.html);
      b.type = 'button';
      b.addEventListener('click', function () {
        resp[q.chave] = o.valor;
        if (passo === 0) rastrear('classic_quiz_inicio', {});
        if (passo < PERGUNTAS.length - 1) { passo++; desenharPergunta(); }
        else mostrarResultado(calcular());
      });
      ops.appendChild(b);
    });
    box.appendChild(ops);
    if (passo > 0) {
      var nav = el('div', 'acl-q__nav');
      var voltar = el('button', 'acl-q__voltar', '← Voltar');
      voltar.type = 'button';
      voltar.addEventListener('click', function () { passo--; desenharPergunta(); });
      nav.appendChild(voltar);
      box.appendChild(nav);
    }
  }

  function cardsDa(pedra) {
    var g = doc.getElementById('pedra-' + pedra.id);
    return g ? Array.prototype.slice.call(g.querySelectorAll('.acl-card')) : [];
  }
  function temBanho(pedra, banho) {
    return cardsDa(pedra).some(function (c) { return c.getAttribute('data-banho') === banho; });
  }

  function calcular() {
    var lista = pedras.map(function (p, ordem) {
      var s = 0;
      if (p.fam === resp.fam) s += 3;
      if ((p.int || []).indexOf(resp.int) > -1) s += 2;
      if (resp.banho && resp.banho !== 'tanto') s += temBanho(p, resp.banho) ? 1 : -2;
      return { p: p, s: s, n: cardsDa(p).length, ordem: ordem };
    });
    lista.sort(function (a, b) { return b.s - a.s || b.n - a.n || a.ordem - b.ordem; });
    return lista.map(function (x) { return x.p; });
  }

  function mostrarResultado(ranking, aviso) {
    var p = ranking[0];
    if (!p) return;
    try { sessionStorage.setItem('acl-quiz', JSON.stringify({ ranking: ranking.slice(0, 3).map(function (x) { return x.id; }), banho: resp.banho || '' })); } catch (e) {}
    rastrear('classic_quiz_resultado', { pedra: p.id });

    box.innerHTML = '';
    var res = el('div', 'acl-res');
    var topo = el('div', 'acl-res__topo');
    topo.innerHTML = '<img class="acl-res__pedra" src="' + esc(p.img) + '" alt="' + esc(p.nome) + '" width="96" height="96">' +
      '<div><p class="acl-eyebrow" style="margin-bottom:4px">A sua pedra é</p><h3 class="acl-res__nome">' + esc(p.nome) + '</h3>' +
      '<p class="acl-res__frase">' + esc(p.frase) + '</p></div>';
    res.appendChild(topo);
    res.appendChild(el('p', 'acl-res__sig', esc(p.sig) + ' <a class="acl-link" href="' + esc(p.ficha) + '">Ler a ficha da pedra</a>'));
    res.appendChild(el('p', 'acl-res__nota', 'Significados da tradição das pedras, para inspirar a escolha. Não são promessa de efeito.'));

    var todos = cardsDa(p);
    var preferidos = todos.slice();
    if (resp.banho && resp.banho !== 'tanto') {
      preferidos = todos.filter(function (c) { return c.getAttribute('data-banho') === resp.banho; })
        .concat(todos.filter(function (c) { return c.getAttribute('data-banho') !== resp.banho; }));
    }
    var grade = el('div', 'acl-res__cards');
    preferidos.slice(0, 6).forEach(function (c) {
      var copia = c.cloneNode(true);
      copia.hidden = false;
      copia.querySelectorAll('.acl-add__msg').forEach(function (m) { m.textContent = ''; });
      grade.appendChild(copia);
    });
    res.appendChild(grade);

    var acoes = el('div', 'acl-res__acoes');
    var ver = el('a', 'button button--primary', todos.length > 1 ? 'Ver as ' + todos.length + ' peças de ' + esc(p.nome) : 'Ver a peça de ' + esc(p.nome));
    ver.href = '#pedra-' + p.id;
    ver.addEventListener('click', function (ev) { ev.preventDefault(); irPara(doc.getElementById('pedra-' + p.id)); });
    var refazer = el('button', 'acl-q__voltar', 'Refazer o quiz');
    refazer.type = 'button';
    refazer.addEventListener('click', function () { resp = {}; passo = 0; desenharPergunta(); });
    acoes.appendChild(ver);
    acoes.appendChild(refazer);
    res.appendChild(acoes);

    var outras = ranking.slice(1, 3);
    if (outras.length) {
      var mais = el('p', 'acl-res__mais', 'Para completar o trio, combinam com você: ');
      outras.forEach(function (o) {
        var b = el('button', 'acl-pill', esc(o.nome));
        b.type = 'button';
        b.addEventListener('click', function () {
          var nova = [o].concat(ranking.filter(function (x) { return x !== o; }));
          mostrarResultado(nova);
          box.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        mais.appendChild(b);
      });
      res.appendChild(mais);
    }

    var tpl = doc.getElementById('acl-quiz-form');
    if (aviso === 'ok') {
      res.appendChild(el('p', 'acl-news__ok', 'Pronto! Você está na nossa lista e vai receber as novidades da linha Classic.'));
    } else if (tpl && tpl.content) {
      var form = tpl.content.cloneNode(true);
      var tags = form.querySelector('[data-acl-tags]');
      if (tags) tags.value = 'newsletter,quiz-classic,pedra-' + p.id;
      res.appendChild(form);
    }
    box.appendChild(res);
  }

  if (box && pedras.length) {
    var posted = /[?&]customer_posted=true/.test(window.location.search);
    var salvo = null;
    try { salvo = JSON.parse(sessionStorage.getItem('acl-quiz') || 'null'); } catch (e) {}
    if (salvo && salvo.ranking && (posted || window.location.hash === '#acl-quiz')) {
      var porId = {};
      pedras.forEach(function (x) { porId[x.id] = x; });
      var rk = salvo.ranking.map(function (id) { return porId[id]; }).filter(Boolean);
      resp.banho = salvo.banho;
      if (rk.length) {
        mostrarResultado(rk, posted ? 'ok' : '');
        if (posted) setTimeout(function () { irPara(doc.getElementById('acl-quiz')); }, 300);
      } else desenharPergunta();
    } else {
      desenharPergunta();
    }
  }
})();
